import React, { createContext, useContext } from "react";

type MapToolContextValue = {
  onMapToolEnter: () => void;
};

export const MapOverlayContext = createContext<MapToolContextValue>({
  onMapToolEnter: () => {},
});

export const MapOverlayProvider = ({
  children,
  onFocusLost,
}: {
  children: React.ReactNode;
  onFocusLost: () => void;
}) => {
  return (
    <MapOverlayContext.Provider
      value={{
        onMapToolEnter: onFocusLost,
      }}
    >
      {children}
    </MapOverlayContext.Provider>
  );
};

export const OverlayItemWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { onMapToolEnter } = useContext(MapOverlayContext);
  return (
    <div style={{ display: "contents" }} onMouseEnter={onMapToolEnter}>
      {children}
    </div>
  );
};
